const endpoint = property => `/api/${property}/report`;
const integrationEndpoint = property => `/api/${property}/integrationReport`;

export default ['api', function (api) {
    return {
        generate: query => {
            var str = [];
            for (var param in query)
                if (query.hasOwnProperty(param) && query[param]) {
                    str.push(encodeURIComponent(param) + "=" + encodeURIComponent(query[param]));
                }
            str = `?${str.join("&")}`;

            return api.get(`${endpoint(api.property())}${str}`).then(response => response.data);
        },
        generateIntegration: query => {
            var str = [];
            for (var param in query)
                if (query.hasOwnProperty(param) && query[param]) {
                    str.push(encodeURIComponent(param) + "=" + encodeURIComponent(query[param]));
                }
            str = `?${str.join("&")}`;

            return api.get(`${integrationEndpoint(api.property())}${str}`).then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/reports/services/reports.service.js